<template>
    <main class="page page-dashboard">
        <div class="container">
            <PageHeader
                :title="$translate.text('general.payment')"
            />
            <div v-if="user === null && status.user_active === 0">
                <div v-if="status.status === 'paid'">
                    <Alert :show="true" type="success">{{ t('general.'+status.status)}}</Alert>
                </div>

                <div v-else-if="status.status === 'open'">
                    <Alert :show="true">{{ t('general.'+status.status)}}</Alert>
                </div>

                <div v-else-if="status.status === 'failed'">
                    <Alert :show="true" type="danger">{{ t('general.'+status.status)}}</Alert>
                </div>

                <div v-else-if="status.status === 'expired'">
                    <Alert :show="true" type="warning">{{ t('general.'+status.status)}}</Alert>
                </div>

                <div v-else-if="status.status === 'canceled'">
                    <Alert :show="true" type="warning">{{ t('general.'+status.status)}}</Alert>
                </div>

            </div>

            <div v-else>
                <div v-if="status.status === 'paid'">
                    <Alert :show="true" type="success">{{ t('general.user.'+status.status)}}</Alert>
                </div>

                <div v-else-if="status.status === 'open'">
                    <Alert :show="true">{{ t('general.user.'+status.status)}}</Alert>
                </div>

                <div v-else-if="status.status === 'failed'">
                    <Alert :show="true" type="danger">{{ t('general.user.'+status.status)}}</Alert>
                </div>

                <div v-else-if="status.status === 'expired'">
                    <Alert :show="true" type="warning">{{ t('general.user.'+status.status)}}</Alert>
                </div>

                <div v-else-if="status.status === 'canceled'">
                    <Alert :show="true" type="warning">{{ t('general.user.'+status.status)}}</Alert>
                </div>

            </div>

        </div>
    </main>
</template>
<script>
import CustomStorage from '@glenngijsberts/customstorage';

import { get } from '@/helpers/http';
import handleError from '@/helpers/error';

import PageHeader from '@/components/PageHeader/PageHeader';
import { getUser } from '@/helpers/auth';


import Alert from '@/components/Alert/Alert';

export default {
    name: 'paymentStatus',

    components: {
        PageHeader,
        Alert,
    },

    created() {
        this.user = getUser();
        this.getPaymentStatus();
    },

    data() {
        return {
            user: [],
            status: {},
        };
    },

    methods: {
        getPaymentStatus() {
            const id = this.$route.params.id;
            get({
                url: `${this.$API_URL}/api/payment/status/${id}`,
            })
                .then((response) => {
                    this.status = response.data.data;

                    if (this.status.status === 'open') {
                        setTimeout(() => {
                            this.getPaymentStatus();
                        }, 2000);
                    } else if (this.status.status === 'paid') {
                        if (this.user !== null) {
                            this.getLastPayment();
                        } else {
                            setTimeout(() => {
                                this.$router.push('/clients/subscription');
                            }, 3000);
                        }
                    } else {
                        // this.staffleOptions = response.data.data;
                        this.staffleOptionsLoaded = true;

                        setTimeout(() => {
                            this.$router.push('/clients/subscription');
                        }, 3000);
                    }
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getLastPayment() {
            get({
                url: `${this.$API_URL}/api/clients/subscriptions`,
            })
                .then((response) => {
                    const auth = CustomStorage.get('auth');
                    auth.user.client.subscription = response.data.data;
                    CustomStorage.set('auth', auth, 60);

                    setTimeout(() => {
                        this.$router.push('/clients/subscription');
                    }, 3000);
                });
        },
    },
};
</script>
<style lang="scss" scoped>

</style>
